import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';
import UniversalTag from './UniversalTag';
import './AssociationTypeSlideout.scss';

interface AssociationTypeSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AssociationTypeSlideout({ isOpen, onClose }: AssociationTypeSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 500px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="association-type-slideout">
        <div className="header">
          <h3>Salesforce Association Types</h3>
        </div>

        <div className="section intro">
          <p>Salesforce allows contacts to be linked to multiple accounts, but each contact can only have one primary account. We use the primary association for the main account (typically a district) and indirect associations for any additional accounts.</p>
          <p>Indirect associations need "Allow users to relate a contact to multiple accounts" enabled in your Salesforce settings (Setup &gt; Feature Settings &gt; Sales &gt; Accounts &gt; Account Settings). If your organization does not allow that, set this export's account associations to a single account on the Options step and the extra links are left out instead.</p>
        </div>

        <div className="section all-statuses">
          <table>
            <tbody>
              <tr>
                <td className="status-cell">
                  <UniversalTag category="PRIMARY" />
                </td>
                <td className="desc">
                  <strong>Primary Association</strong>
                  <p>This account will be set as the contact's primary account (Contact.AccountId). The contact will appear in the "Contacts" related list on the Account page and in the main Contacts tab.</p>
                </td>
              </tr>
              <tr>
                <td className="status-cell">
                  <UniversalTag category="INDIRECT" />
                </td>
                <td className="desc">
                  <strong>Indirect Association</strong>
                  <p>This account will be linked via AccountContactRelation. The contact will appear in the "Related Contacts" related list on the Account page, but not in the main Contacts or Companies tabs. This is used for secondary affiliations.</p>
                </td>
              </tr>
              <tr>
                <td className="status-cell">
                  <UniversalTag category="NOT_LINKED" />
                </td>
                <td className="desc">
                  <strong>Not Linked</strong>
                  <p>This export links each contact to a single account, so this one is left out. Nothing already in Salesforce is removed. To link every account instead, change this export's account associations on the Options step.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
